import type { BreadcrumbItem } from '#/components/ui/Breadcrumbs';
import { SECTOR_SLUG_BY_LABEL } from '#/lib/category-navigation';

export function getEquityBreadcrumbItems(
  breadcrumbs: BreadcrumbItem[],
  sectorLabel?: string | null,
): BreadcrumbItem[] {
  const sectorSlug = sectorLabel
    ? SECTOR_SLUG_BY_LABEL[sectorLabel]
    : undefined;

  return sectorLabel && sectorSlug
    ? [...breadcrumbs, { label: sectorLabel, href: `/${sectorSlug}` }]
    : breadcrumbs;
}
